/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Purchase_OrdersInputs */

const en_nav_purchase_orders = /** @type {(inputs: Nav_Purchase_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase orders`)
};

/**
* | output |
* | --- |
* | "Purchase orders" |
*
* @param {Nav_Purchase_OrdersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_purchase_orders = /** @type {((inputs?: Nav_Purchase_OrdersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Purchase_OrdersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_purchase_orders(inputs)
});